module.exports = __webpack_public_path__ + "static/media/instagram-logo.eddb0664.svg";